import React from 'react';
import homePage from '../Components/images/home.jpg';

const home = () => {
    return(
        <img src={homePage} className='homeImg' alt='homepage'/>
    )
}

export default home;